import { asCurrency } from './payments.utils'

function install (Vue) {
  Vue.prototype.asCurrency = asCurrency
}

export default install
